import { formatNumber, roundNumber } from '@pretto/bricks/core/utility/formatters'
import { useTooltip } from '@pretto/bricks/core/utility/tooltip'

import PropTypes from 'prop-types'
import { Fragment } from 'react'

import * as S from './styles'

const TooltipContent = ({ cost, duration, interests, payment }) => (
  <S.Tooltip>
    <div>
      Durée : <strong>{formatNumber(duration, { suffix: 'ans' })}</strong>
    </div>
    <div>
      Mensualité : <strong>{formatNumber(roundNumber(payment), { suffix: '€' })}</strong>
    </div>
    <S.TooltipInterests>(dont {formatNumber(roundNumber(interests), { suffix: '€' })} d'intérêts)</S.TooltipInterests>
    <div>
      Coût total : <strong>{formatNumber(roundNumber(cost), { suffix: '€' })}</strong>
    </div>
  </S.Tooltip>
)
TooltipContent.propTypes = {
  cost: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,
  interests: PropTypes.number.isRequired,
  payment: PropTypes.number.isRequired,
}
export const Graph = ({ bars, paymentSteps, principalSteps, ...props }) => {
  const [setRefController, tooltipComponent] = useTooltip()
  const [maxPaymentStep] = paymentSteps
  const [maxPrincipalStep] = principalSteps
  return (
    <S.GraphContainer {...props}>
      <S.Title>choisissez bien votre durée</S.Title>

      <S.Graph $bars={bars.length} $steps={paymentSteps.length}>
        <S.PaymentTitle>Mensualités</S.PaymentTitle>
        <S.TotalTitle>Coût total</S.TotalTitle>
        {paymentSteps.map((payment, i) => (
          <Fragment key={i}>
            <S.Line $index={i} $isLast={i === paymentSteps.length - 1} />
            <S.PaymentValue $index={i}>{formatNumber(payment)}</S.PaymentValue>
          </Fragment>
        ))}
        {principalSteps.map((principal, i) => {
          const roundedPrincipal = roundNumber(principal, 1000) / 1000
          return (
            <S.TotalValue key={i} $index={i}>
              {roundedPrincipal}
              {roundedPrincipal > 0 && 'K'}
            </S.TotalValue>
          )
        })}
        {tooltipComponent}
        {bars.map(({ duration, totalPayment, principal, totalCost, isActive }, i) => (
          <Fragment key={i}>
            <S.BarContainer $index={i}>
              <S.Bar
                ref={setRefController.bind(
                  null,
                  <TooltipContent
                    cost={totalCost}
                    duration={duration}
                    payment={totalPayment}
                    interests={totalPayment - principal}
                  />
                )}
              >
                <S.BarPrincipal style={{ height: `${(principal / maxPaymentStep) * 100}%` }} />
                <S.BarInterests style={{ height: `${(totalPayment / maxPaymentStep) * 100}%` }} />
                <S.DotTotal style={{ bottom: `${(totalCost / maxPrincipalStep) * 100}%` }} />
              </S.Bar>
            </S.BarContainer>
            <S.BarDuration $index={i} $isActive={isActive}>
              {duration} ans
            </S.BarDuration>
          </Fragment>
        ))}
        <S.Legends>
          <S.Legend $dotColor="primary2">Capital / mois</S.Legend>
          <S.Legend $dotColor="primary3">Intérêts / mois</S.Legend>
          <S.Legend $dotColor="accent1">Coût total du crédit</S.Legend>
        </S.Legends>
      </S.Graph>
    </S.GraphContainer>
  )
}

Graph.propTypes = {
  bars: PropTypes.arrayOf(
    PropTypes.shape({
      duration: PropTypes.number.isRequired,
      isActive: PropTypes.bool,
      principal: PropTypes.number.isRequired,
      totalCost: PropTypes.number.isRequired,
      totalPayment: PropTypes.number.isRequired,
    })
  ).isRequired,
  paymentSteps: PropTypes.arrayOf(PropTypes.number).isRequired,
  principalSteps: PropTypes.arrayOf(PropTypes.number).isRequired,
}
